/**
 * Módulo: Plataforma Configuración
 * Grupo del sidebar — mitad "configuración" del split de la sección Plataforma
 * (7-jul-2026, Mariano). Debajo de Supervisión, junto a Plataforma Operación.
 *
 * Acá viven solo los ÍTEMS del menú; las rutas siguen en `plataforma/config.js`.
 * Mismo patrón que Supervisión. "Items del sidebar" se descartó (no se usa).
 */
export default {
  id: 'plataforma-configuracion',
  nombre: 'Plataforma Configuración',
  descripcion: 'Sección de configuración de la plataforma',
  icono: 'settings',
  tipo: 'admin',
  version: '0.1.0',

  routes: [],

  menuItems: [
    // 10-jul-2026 (Mariano): "Tareas y SLAs" (antes "SLAs") + Agentes segundo —
    // el corazón de Detección de tareas junto arriba del menú.
    { label: 'Tareas y SLAs', path: '/slas', icon: 'clock', permisoModulo: 'slas' },
    { label: 'Agentes', path: '/agentes', icon: 'cpu', permisoModulo: 'agentes' },
    { label: 'Accionables', path: '/accionables', icon: 'zap', permisoModulo: 'accionables' },
    { label: 'Frameworks', path: '/frameworks', icon: 'layers', permisoModulo: 'frameworks' },
    { label: 'Dimensiones', path: '/dimensiones', icon: 'sliders', permisoModulo: 'dimensiones' },
    { label: 'Motor criticidad', path: '/motor-criticidad', icon: 'gauge', permisoModulo: 'motor-criticidad' },
    { label: 'Reportes', path: '/reportes', icon: 'bar-chart-2', permisoModulo: 'reportes' },
    { label: 'Catálogo', path: '/catalogo', icon: 'database', permisoModulo: 'configuracion' },
    { label: 'Módulos', path: '/modulos-plataforma', icon: 'layers', permisoModulo: 'modulos-plataforma' },
    { label: 'Planes', path: '/planes', icon: 'award', permisoModulo: 'planes' },
    { label: 'IA', path: '/ia', icon: 'brain', permisoModulo: 'ia-config' },
    { label: 'APIs', path: '/api-terceros', icon: 'plug', permisoModulo: 'api-terceros' },
    { label: 'Biblioteca', path: '/biblioteca', icon: 'book-open', permisoModulo: 'biblioteca' },
    { label: 'Protocolos', path: '/protocolos', icon: 'file-text', permisoModulo: 'protocolos' },
    { label: 'Vista detallada de empresa', path: '/vistas-empresa', icon: 'list', permisoModulo: 'modulos-plataforma' },
  ],

  features: [],

  // El grupo se muestra si el rol tiene 'ver' sobre alguno de estos módulos del
  // catálogo (o es Wizard, que ve todo).
  permisoModulos: [
    'slas', 'accionables', 'frameworks', 'dimensiones', 'motor-criticidad',
    'reportes', 'configuracion', 'modulos-plataforma', 'planes', 'ia-config',
    'api-terceros', 'agentes', 'biblioteca', 'protocolos',
  ],

}
